import {HttpClient} from "@angular/common/http";
import {IModuleTranslationOptions, ModuleTranslateLoader} from "@larscom/ngx-translate-module-loader";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

export function HttpLoaderFactoryTranslate(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
